const LOG_PREFIX = '[presence]'

export function isPresenceDebugEnabled(): boolean {
  return import.meta.env.VITE_PRESENCE_DEBUG === 'true'
}

export function presenceDebug(_message: string, _data?: Record<string, unknown>): void {
  if (!isPresenceDebugEnabled()) return
  if (_data !== undefined) {
    console.log(`${LOG_PREFIX} ${_message}`, _data)
  } else {
    console.log(`${LOG_PREFIX} ${_message}`)
  }
}

export function presenceDebugWarn(_message: string, _data?: Record<string, unknown>): void {
  if (!isPresenceDebugEnabled()) return
  if (_data !== undefined) {
    console.warn(`${LOG_PREFIX} ${_message}`, _data)
  } else {
    console.warn(`${LOG_PREFIX} ${_message}`)
  }
}
